import OpDetail from './OpDetail';

export default OpDetail;
